import type { OracordEngineAdminCheck } from '@oracord/shared';

type EngineSetupCheckSource = {
  checks?: readonly OracordEngineAdminCheck[] | null;
};

export type CustomerReadyEngineMark = 'Engine installed' | 'Paired' | 'Business setup loaded' | 'Running';
export type CustomerVisibleEngineMark = Exclude<CustomerReadyEngineMark, 'Business setup loaded'>;

export type EngineSetupStatusItem = {
  mark: CustomerVisibleEngineMark;
  label: string;
  readyLabel: string;
  notReadyLabel: string;
  done: boolean;
};

const ENGINE_SETUP_STATUS_LABELS: Array<Omit<EngineSetupStatusItem, 'done'>> = [
  { mark: 'Engine installed', label: 'Install status', readyLabel: 'Installed', notReadyLabel: 'Not installed' },
  { mark: 'Paired', label: 'Pairing status', readyLabel: 'Paired', notReadyLabel: 'Not paired' },
  { mark: 'Running', label: 'Running status', readyLabel: 'Running', notReadyLabel: 'Not running' },
];

export function engineSetupCheckDone(engine: EngineSetupCheckSource | null | undefined, label: CustomerReadyEngineMark): boolean {
  return engine?.checks?.some(check => check.label === label && check.status === 'ready') ?? false;
}

export function engineSetupStatusItems(engine: EngineSetupCheckSource | null | undefined): EngineSetupStatusItem[] {
  return ENGINE_SETUP_STATUS_LABELS.map(item => ({ ...item, done: engineSetupCheckDone(engine, item.mark) }));
}
